import React, { useEffect, useRef, useState } from 'react'

export interface Option {
  value: string
  label: string
}

interface Props {
  onChange: (val: string) => void
  value: string
  options: Option[]
  placeholder: string
}

const Select = ({ onChange, options, value, placeholder }: Props) => {
  const selectRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  const handleOptionClick = (val: string) => {
    setIsOpen(false)
    onChange(val)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div
      ref={selectRef}
      className="border-slateGray border rounded-md px-3 py-3 relative cursor-pointer bg-white text-black">
      <div
        onClick={() => {
          setIsOpen((val) => !val)
        }}
        className="flex items-center">
        <div className="text-slateGray text-ellipsis overflow-hidden max-h-6">
          {options.find((item) => item.value === value)?.label ?? placeholder}
        </div>
      </div>
      {isOpen && (
        <div className="absolute bg-white w-full left-0 top-[103%] rounded-m z-40 border border-slateGray rounded-md max-h-[20rem] overflow-y-auto hide-scrollbar">
          {options.map(({ label, value }) => (
            <div
              onClick={() => {
                handleOptionClick(value)
              }}
              key={value}
              className="border-b border-lightBorder px-2 py-2 hover:bg-coolGray hover:text-white text-ellipsis overflow-hidden">
              <div className="text-ellipsis max-h-6 overflow-hidden">{label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Select
